import { IconCloudDownload, IconXboxX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Button, Form } from 'react-bootstrap';
import { AiOutlineCheckCircle } from 'react-icons/ai';
import { Loader } from './Loader';
import { baseURL } from '../../Utils/constants/constant';
import { PostRequest } from '../../Utils/hooks/ApiHandler';
import { useNavigate } from 'react-router-dom';
import { downloadCSVForImportModule } from '../../Utils/helpers/commonhelper';
import { toast } from 'sonner';
import { modules } from './SampleModules';

export const ImportStep1 = ({
    headers,
    extras,
    data,
    loading,
    files,
    setFiles,
    currentStep,
    setCurrStep,
    currentSelected,
    setCurrSelected,
    setFileHeaders,
    setValues,
    module_name
}) => {
    const navigate = useNavigate()
    const [fetchingStatus, setFetchingStatus] = useState(false);

    function getCompanyRecord(module_name) {
        const module = modules.find((m) => m.name === module_name);
        if (!module) return null;

        downloadCSVForImportModule(module.fileName, module.headers, module.data);
    }

    const handleDrop = async (event) => {
        event.preventDefault();
        const droppedFiles = event.dataTransfer.files;

        if (!droppedFiles || droppedFiles.length === 0) return;
        const file = droppedFiles[0];
        setFiles([file]);
    };

    const handleRemoveFile = (index) => {
        setFiles((prevFiles) => prevFiles?.filter((_, i) => i !== index));
    };
    const handleUploadFile = async (file) => {
        try {
            setFetchingStatus(true);
            if (!file) return;
            const payload = {
                csv_file: file,
                module_name: module_name
            };

            const res = await PostRequest(
                `${baseURL}csv/upload_file/`,
                payload,
                true,
                { headers },
                extras
            );
            if (res.status === "fail" || res.success === false) {
                toast.warning(res.message)
                setFetchingStatus(false)
                return
            }
            setFetchingStatus(false);
            setFileHeaders(
                res.labels?.map((l) => ({
                    value: l.toLowerCase()?.split(" ")?.join("_"),
                    label: l,
                }))
            );
            setValues(res.data);
            return true;
        } catch (error) {
            setFetchingStatus(false);
            return false;
        }
    };
    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <>
                    {/* Added Step Count Header */}
                    <div
                        style={{ alignSelf: "center", width: "45%" }}
                        className="d-flex justify-content-between align-items-center mb-3"
                    >
                        <span></span>
                        <span className="badge bg-light text-dark border fw-normal">
                            Step 1 of 3
                        </span>
                    </div>

                    <div style={{ alignSelf: "center", width: "45%" }}>
                        <div
                            style={{
                                backgroundColor: "#f7e8f0",
                                padding: "1rem",
                                borderRadius: "8px",
                                border: "2px dashed #7a3a5e",
                            }}
                            className="mb-2"
                        >
                            <div
                                style={{
                                    padding: "10px",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    position: "relative",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                }}
                                onDrop={handleDrop}
                                onDragOver={(event) => event.preventDefault()}
                            >
                                <>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            marginBottom: "1rem",
                                        }}
                                    >
                                        <div
                                            className="shadow-sm d-flex align-items-center justify-content-center"
                                            style={{
                                                backgroundColor: "white",
                                                width: "50px",
                                                height: "50px",
                                                borderRadius: "50%",
                                            }}
                                        >
                                            <IconCloudDownload stroke={2} />
                                        </div>
                                        <div>
                                            <p style={{ fontSize: "1rem" }}>
                                                Drag and drop your files here
                                            </p>
                                        </div>
                                    </div>
                                    <input
                                        type="file"
                                        hidden
                                        id="browse"
                                        accept=".csv"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];
                                            if (file) setFiles([file]);
                                        }}
                                    />
                                    <label htmlFor="browse" className="btn btn-default">
                                        Browse files
                                    </label>
                                </>

                                {files.length > 0 && (
                                    <div>
                                        <div>
                                            {files.map((file, index) => (
                                                <div
                                                    className="d-flex align-items-center  gap-1"
                                                    key={index}
                                                >
                                                    <p>{file.name}</p>
                                                    <IconXboxX
                                                        stroke={2}
                                                        size={18}
                                                        style={{ stroke: "red", cursor: "pointer" }}
                                                        onClick={() => handleRemoveFile(index)}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {files.length > 0 && (
                                    <div className="d-flex align-items-center gap-2">
                                        <AiOutlineCheckCircle style={{ color: "#6DC24B" }} />
                                        <p>{files.length} file(s) selected</p>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div>
                            <span
                                className="fs-14"
                                style={{
                                    color: "#646464",
                                    margin: 0,
                                }}
                            >
                                {" "}
                                Download a{" "}
                                <span
                                    style={{ color: "blue", cursor: "pointer" }}
                                    onClick={() => { getCompanyRecord(data?.module_name) }}
                                >
                                    sample file
                                </span>{" "}
                                and compare it to your import file to ensure you have the
                                file perfect for the import.
                            </span>
                            <div
                                className="mt-2"
                                style={{
                                    background: "#fff8e1",
                                    border: "1px solid #ffe082",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                }}
                            >
                                <span
                                    className="fs-12"
                                    style={{ color: "#8a6d3b", fontWeight: 500 }}
                                >
                                    Note: Maximum 2000 rows are allowed per import file.
                                </span>
                            </div>

                            {data?.module_name === "company" ||
                                data?.module_name === "contact" ? (
                                <div className="d-flex mt-3  w-100">
                                    <span
                                        className="fs-12"
                                        style={{
                                            margin: 0,
                                            color: "red",
                                            textWrap: "nowrap",
                                        }}
                                    >
                                        Duplicate Heading{" "}
                                        <span style={{ color: "red" }}>*</span>
                                    </span>
                                    <div
                                        className="d-flex flex-column gap-2"
                                        style={{ marginLeft: "10rem" }}
                                    >
                                        <>
                                            {" "}
                                            <div className="d-flex gap-4">
                                                <div className="d-flex align-items-start gap-2">
                                                    <Form.Check
                                                        type="radio"
                                                        className="custom-radio"
                                                        onChange={() => setCurrSelected("skip")}
                                                        checked={currentSelected === "skip"}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                    <div>
                                                        <span
                                                            style={{
                                                                fontSize: "0.86rem",
                                                                fontWeight: "500",
                                                            }}
                                                        >
                                                            Skip Duplicates
                                                        </span>
                                                        <p className="fs-12">
                                                            Retains the items and does not import the
                                                            duplicates in the import file.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex gap-4">
                                                <div className="d-flex align-items-start gap-2">
                                                    <Form.Check
                                                        type="radio"
                                                        checked={currentSelected === "duplicate"}
                                                        className="custom-radio"
                                                        onChange={() => setCurrSelected("duplicate")}
                                                        style={{ cursor: "pointer" }}
                                                    />
                                                    <div>
                                                        <span
                                                            style={{
                                                                fontSize: "0.86rem",
                                                                fontWeight: "500",
                                                            }}
                                                        >
                                                            Overwrite Items
                                                        </span>
                                                        <p className="fs-12">
                                                            Imports the duplicate in the import file and
                                                            overwrites the existing items.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div
                            className="d-flex justify-content-between "
                            style={{ marginTop: "8rem" }}
                        >
                            <Button
                                className="btn btn-default-outline"
                                onClick={() => navigate(-1)}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn-default d-flex align-items-center gap-2"
                                disabled={files.length === 0 || fetchingStatus}
                                onClick={async () => {
                                    if (currentStep === 1 && files.length > 0) {
                                        const success = await handleUploadFile(files[0]);
                                        if (!success) return;
                                    }
                                    setCurrStep((prev) => prev + 1);
                                }}
                            >
                                {fetchingStatus ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        Uploading...
                                    </>
                                ) : (
                                    "Next"
                                )}
                            </Button>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}
